import { CustomForm } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  page: number;
  limit: number;
}

interface ResponseDataType {
  response: CustomForm[];
}

export const getCustomFormsListRequest = ({ token, page, limit }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form?page=${ page }&limit=${ limit }`, {
    token,
  });
};